// Where the simulator's API lives.
//
// Under `python -m playground serve` the viewer and the API are one origin: every
// request is relative to the page, which is what an empty `<meta name="pg-api">` means
// and what the page has always done. A tree exported for a host that runs no code
// (`python -m playground export --api URL`, GitHub Pages) carries the API's URL in that
// meta instead -- and then a run the API makes lives where the API is, not beside the
// page, so the viewer has to name it absolutely.

const meta = document.querySelector('meta[name="pg-api"]');
const here = new URL("./", location.href);              // the page's own directory
export const API = new URL((meta && meta.content.trim()) || "./", location.href);

// The API is beside the page: URLs stay relative, exactly as they were before this
// module existed, and every run is under `runs/<key>/` beside the page too. When it is
// not, a run the API made lives at the API and `?run=<key>` is opened from there
// instead (js/load.js, and the bootstrap in index.html).
export const apiIsLocal = API.href === here.href;

export const api = (path) => new URL(path, API).href;
